import { map } from 'mobx';
import { createStore } from 'satcheljs';
export default createStore('sweepRulesOption', {
    hasLoggedGetSweepRulesInformation: false,
    getSweepRulesRequestStatus: 0 /* NotInitiated */,
    sweepRules: map({}),
    sweepRuleIds: [],
})();
//# sourceMappingURL=store.js.map